import React from "react";
import {
  PiSquaresFourLight,
  PiGraduationCapLight,
  PiGlobeLight,
} from "react-icons/pi";
import { ContentContainer } from "coaz-ui";

const applications = [
  {
    name: "CPDs",
    url: "https://cpd.coaz.org/",
    Icon: PiGraduationCapLight,
    image: "/images/cpd_bg_5.jpg",
  },
  {
    name: "Website",
    url: "https://coaz.org/",
    Icon: PiGlobeLight,
    image: "/images/cms_1.jpg",
  },
];

const ApplicationCard = ({ name, description, url, Icon, image }) => {
  const available = Boolean(url);
  const base =
    "flex flex-col items-center w-full h-full overflow-hidden rounded-xl bg-white";

  const content = (
    <>
      <div className='relative w-full h-40 bg-[rgba(8,81,137,0.08)]'>

    {image ? (
        <img src={image} alt={name} className='absolute inset-0 w-full h-full object-cover' />
    ) : (
        <div className='flex items-center justify-center w-full h-full'>
            <img src='/logo.png' alt='COAZ logo' className='h-28 w-28 object-contain ' />
        </div>
    )}
        <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 flex items-center justify-center w-12 h-12 rounded-full bg-white border border-[rgba(0,0,0,.08)] shadow-sm">
          <Icon size={26} className="text-[rgb(0,175,240)]" />
        </div>
      </div>

      <div className="flex flex-col items-center p-5 pt-9 space-y-1">
        <p className="text-sm text-[rgb(68,71,70)] text-center">{name}</p>
        <p className="text-xs text-[rgb(145,145,145)] tracking-wider">
          {available ? description : `${description} (coming soon)`}
        </p>
      </div>
    </>
  );

  if (!available) {
    return (
      <div className={`${base} opacity-50 cursor-not-allowed`}>{content}</div>
    );
  }
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={`${base} hover:bg-[rgba(0,0,0,.04)] hover:shadow-md transition`}
    >
      {content}
    </a>
  );
};

const Dashboard = () => {
  return (
    <ContentContainer
      Icon={PiSquaresFourLight}
      text="Dashboard"
      scrollable={true}
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 w-full h-auto p-4 overflow-x-auto overflow-y-hidden">
        {applications.map((app) => (
          <ApplicationCard key={app.name} {...app} />
        ))}
      </div>
    </ContentContainer>
  );
};

export default Dashboard;
